import { FC, ReactNode } from 'react';
import { Button } from 'react-bootstrap';
import { FaLocationDot } from 'react-icons/fa6';

interface LocationButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    height?: number;
    width?: number;
    size?: 'lg' | 'sm' | undefined;
    children: ReactNode;
    href?: string;
}

export const LocationButton: FC<LocationButtonProps> = ({
                                                            height,
                                                            width,
                                                            size,
                                                            children,
                                                            ...rest
                                                        }) => {
    return (
        <Button
            size={size}
            {...rest}
            style={{
                height: height ?? 40,
                ...(width !== undefined ? { width } : {}),
                backgroundColor: '#6098B8',
                borderColor: '#6098B8',
                borderRadius: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
            className={`${rest.className} text-uppercase`}
        >
            <FaLocationDot
                size={16}
                color="#fff"
                className="me-2"
            />
            {children}
        </Button>
    );
};